function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 700",
    style: {
      enableBackground: "new 0 0 1000 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Bg"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1000 700)",
    style: {
      fill: "#EFF0ED"
    },
    width: 1000,
    height: 700
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.18
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 292.266,
    y: 471.039,
    style: {
      fill: "#B5C3C2"
    },
    width: 40.399,
    height: 77.585
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.867,
    y: 521.583,
    style: {
      fill: "#B5C3C2"
    },
    width: 27.197,
    height: 32.604
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.923,
    y: 539.63,
    style: {
      fill: "#B5C3C2"
    },
    width: 15.086,
    height: 18.085
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5C3C2"
    },
    points: "317.606,548.422 307.325,548.422 307.325,560.746 311.034,560.746 314.709,560.746  317.606,560.746  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5C3C2"
    },
    points: "311.788,553.789 310.673,553.789 310.673,566.113 311.076,566.113 311.474,566.113  311.788,566.113  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5C3C2"
    },
    points: "314.258,558.049 313.143,558.049 313.143,570.373 313.545,570.373 313.944,570.373  314.258,570.373  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 291.188,
    y: 547.997,
    style: {
      fill: "#B5C3C2"
    },
    width: 42.554,
    height: 0.826
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.875,
    y: 553.789,
    style: {
      fill: "#B5C3C2"
    },
    width: 29.182,
    height: 0.795
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.823,
    y: 557.439,
    style: {
      fill: "#B5C3C2"
    },
    width: 16.817,
    height: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.368,
    y: 549.447,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 1.264,
    height: 3.417
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.866,
    y: 549.447,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 1.265,
    height: 3.417
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.365,
    y: 549.447,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 1.265,
    height: 3.417
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.863,
    y: 549.447,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 1.265,
    height: 3.417
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.361,
    y: 549.447,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 1.265,
    height: 3.417
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.86,
    y: 549.447,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 1.265,
    height: 3.417
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.358,
    y: 549.447,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 1.265,
    height: 3.417
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 541.477,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 541.477,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 541.477,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 541.477,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 541.477,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 541.477,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 535.16,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 535.16,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 535.16,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 535.16,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 535.16,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 535.16,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 528.842,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 528.842,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 528.842,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 528.842,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 528.842,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 528.842,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 522.524,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 522.524,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 522.524,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 522.524,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 522.524,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 522.524,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 516.206,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 516.206,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 516.206,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 516.206,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 516.206,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 516.206,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 509.888,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 509.888,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 509.888,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 509.888,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 509.888,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 509.888,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 503.57,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 503.57,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 503.57,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 503.57,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 503.57,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 503.57,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 497.252,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 497.252,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 497.252,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 497.252,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 497.252,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 497.252,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 490.934,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 490.934,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 490.934,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 490.934,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 490.934,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 490.934,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 484.616,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 484.616,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 484.616,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 484.616,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 484.616,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 484.616,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 478.299,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 478.299,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 478.299,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 478.299,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 478.299,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 478.299,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 4.053
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 174.937,
    y: 480.314,
    style: {
      fill: "#B5C3C2"
    },
    width: 64.942,
    height: 65.359
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.092,
    y: 544.949,
    style: {
      fill: "#B5C3C2"
    },
    width: 68.633,
    height: 1.847
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.12,
    y: 540.381,
    style: {
      fill: "#B5C3C2"
    },
    width: 60.576,
    height: 8.781
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.757,
    y: 543.16,
    style: {
      fill: "#B5C3C2"
    },
    width: 23.988,
    height: 9.594
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5C3C2"
    },
    points: "195.639,550.05 181.757,550.05 181.757,555.1 191.713,555.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.352,
    y: 548.043,
    style: {
      fill: "#B5C3C2"
    },
    width: 1.346,
    height: 11.249
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#B5C3C2"
    },
    cx: 188.025,
    cy: 559.875,
    rx: 1.209,
    ry: 0.583
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5C3C2"
    },
    points: "777.666,475.339 706.578,475.339 697.707,571.434 777.666,563.426  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5C3C2"
    },
    points: "467.521,530.218 467.521,562.345 456.372,562.345 456.372,570.95 452.389,570.95  452.389,583.571 430.445,583.571 430.445,592.848 428.492,592.848 428.492,583.571 424.193,583.571 424.193,595.183  422.241,595.183 422.241,583.571 408.368,583.571 408.368,562.345 401.202,562.345 401.202,530.218 395.059,530.218  395.059,471.701 471.84,471.701 471.84,530.218  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 84.175,
    y: 466.783,
    style: {
      fill: "#B5C3C2"
    },
    width: 849.37,
    height: 9.747
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#95A9A7"
    },
    points: "584.14,469.172 546.529,469.172 561.184,505.509 584.14,505.509  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.701,
    y: 452.388,
    style: {
      fill: "#95A9A7"
    },
    width: 891.8,
    height: 15.369
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#95A9A7"
    },
    points: "553.317,536.415 553.317,552.517 541.241,552.517 541.241,558.648 534.78,558.648  534.78,563.797 532.513,563.797 532.513,572.625 531.927,572.625 531.927,563.797 529.659,563.797 529.659,558.648  523.198,558.648 523.198,552.517 511.214,552.517 511.214,536.415 508.723,536.415 508.723,507.18 490.142,507.18  490.142,473.855 508.723,473.855 527.305,473.855 555.716,473.855 555.716,536.415  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#95A9A7"
    },
    points: "622.722,517.918 564.268,517.918 564.268,517.405 566.913,517.405 566.913,469.716  620.077,469.716 620.077,517.405 622.722,517.405  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.346,
    y: 466.314,
    style: {
      fill: "#95A9A7"
    },
    width: 51.826,
    height: 39.725
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.408,
    y: 466.314,
    style: {
      fill: "#95A9A7"
    },
    width: 89.132,
    height: 19.372
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.183,
    y: 481.395,
    style: {
      fill: "#95A9A7"
    },
    width: 19.567,
    height: 47.572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.503,
    y: 515.787,
    style: {
      fill: "#95A9A7"
    },
    width: 1.016,
    height: 25.871
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.807,
    y: 513.825,
    style: {
      fill: "#95A9A7"
    },
    width: 1.016,
    height: 25.871
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.692,
    y: 525.534,
    style: {
      fill: "#95A9A7"
    },
    width: 11.96,
    height: 6.376
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.047,
    y: 466.314,
    style: {
      fill: "#95A9A7"
    },
    width: 34.052,
    height: 32.614
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.573,
    y: 466.314,
    style: {
      fill: "#95A9A7"
    },
    width: 63.921,
    height: 67.128
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.853,
    y: 524.568,
    style: {
      fill: "#95A9A7"
    },
    width: 51.361,
    height: 11.181
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.618,
    y: 531.253,
    style: {
      fill: "#95A9A7"
    },
    width: 73.831,
    height: 0.785
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.992,
    y: 466.314,
    style: {
      fill: "#95A9A7"
    },
    width: 30.119,
    height: 33.901
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.27,
    y: 466.314,
    style: {
      fill: "#95A9A7"
    },
    width: 34.561,
    height: 35.189
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 148.452,
    y: 466.314,
    style: {
      fill: "#95A9A7"
    },
    width: 68.867,
    height: 44.752
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.434,
    y: 511.066,
    style: {
      fill: "#95A9A7"
    },
    width: 74.664,
    height: 1.717
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.501,
    y: 508.369,
    style: {
      fill: "#95A9A7"
    },
    width: 30.265,
    height: 9.073
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.652,
    y: 511.925,
    style: {
      fill: "#95A9A7"
    },
    width: 5.082,
    height: 5.517
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.817,
    y: 511.925,
    style: {
      fill: "#95A9A7"
    },
    width: 5.591,
    height: 5.517
  })), /*#__PURE__*/React.createElement("rect", {
    x: 118.465,
    y: 466.314,
    style: {
      fill: "#95A9A7"
    },
    width: 36.085,
    height: 13.61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.835,
    y: 466.314,
    style: {
      fill: "#95A9A7"
    },
    width: 17.087,
    height: 19.372
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.175,
    y: 466.314,
    style: {
      fill: "#95A9A7"
    },
    width: 29.204,
    height: 6.805
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.215,
    y: 466.314,
    style: {
      fill: "#95A9A7"
    },
    width: 359.849,
    height: 15.081
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A9A7"
    },
    d: "M757.654,521.055c0-1.152-1.936-2.086-4.325-2.086c-2.349,0-4.259,0.904-4.321,2.03l-5.066,0.079 c-0.255-3.407-1.879-6.698-4.745-9.725l4.648-1.035c0.616,0.79,2.196,1.352,4.048,1.352c2.388,0,4.324-0.934,4.324-2.086 s-1.936-2.086-4.324-2.086s-4.324,0.934-4.324,2.086c0,0.176,0.046,0.348,0.131,0.511l-4.706,1.048 c-2.595-2.676-6.166-5.142-10.625-7.293c-0.352-0.17-0.709-0.337-1.069-0.501l4.255-2.191c0.699,0.234,1.548,0.372,2.463,0.372 c2.388,0,4.325-0.934,4.325-2.087c0-1.152-1.936-2.086-4.325-2.086c-2.388,0-4.324,0.934-4.324,2.086 c0,0.627,0.574,1.189,1.481,1.571l-4.225,2.176c-2.997-1.345-6.263-2.506-9.737-3.471l26.075-23.188h4.68v-0.663h2.292v-1.317 H631.124v1.317h2.292v0.663h4.68l26.075,23.188c-4.03,1.119-7.78,2.502-11.156,4.131c-0.352,0.17-0.698,0.342-1.039,0.516 l-3.311-1.497c0.63-0.362,1.01-0.83,1.01-1.34c0-1.152-1.936-2.087-4.325-2.087s-4.324,0.934-4.324,2.087 c0,1.152,1.936,2.086,4.324,2.086c1.158,0,2.209-0.22,2.986-0.578l3.311,1.497c-4.814,2.497-8.49,5.379-10.9,8.498l-4.23-0.751 c0.123-0.193,0.189-0.398,0.189-0.611c0-1.152-1.936-2.086-4.325-2.086s-4.324,0.934-4.324,2.086 c0,1.152,1.936,2.086,4.324,2.086c1.778,0,3.305-0.518,3.969-1.258l4.231,0.752c-2.085,2.777-3.173,5.737-3.173,8.778 c0,0.24,0.008,0.48,0.021,0.719l-5.153,0.081c-0.183-1.071-2.042-1.913-4.308-1.913c-2.388,0-4.324,0.934-4.324,2.086 c0,1.152,1.936,2.086,4.324,2.086c2.348,0,4.258-0.903,4.321-2.029l5.155-0.081c0.255,3.407,1.879,6.698,4.745,9.725 l-3.992,0.889c-0.688-0.712-2.185-1.206-3.921-1.206c-2.388,0-4.324,0.934-4.324,2.086s1.936,2.086,4.324,2.086 c2.388,0,4.324-0.934,4.324-2.086c0-0.232-0.08-0.456-0.225-0.665l4.016-0.894c2.595,2.676,6.165,5.142,10.624,7.293 c0.352,0.17,0.709,0.337,1.069,0.501l-3.155,1.624c-0.76-0.32-1.753-0.514-2.841-0.514c-2.388,0-4.325,0.934-4.325,2.086 c0,1.152,1.936,2.086,4.325,2.086s4.324-0.934,4.324-2.086c0-0.544-0.432-1.039-1.139-1.411l3.16-1.627 c5.361,2.406,11.578,4.223,18.311,5.382L671,548.638c-0.378-0.052-0.777-0.081-1.19-0.081c-2.388,0-4.325,0.934-4.325,2.086 c0,1.152,1.936,2.086,4.325,2.086s4.324-0.934,4.324-2.086c0-0.871-1.108-1.618-2.68-1.93l1.744-2.387 c5.552,0.928,11.446,1.411,17.495,1.411c0.498,0,0.995-0.004,1.491-0.01l0.198,2.937c-2.096,0.145-3.708,1.014-3.708,2.065 c0,1.152,1.936,2.086,4.324,2.086s4.324-0.934,4.324-2.086s-1.936-2.086-4.324-2.086c-0.046,0-0.092,0.001-0.137,0.002 l-0.197-2.924c6.282-0.109,12.373-0.742,18.059-1.854l1.817,2.134c-1.512,0.325-2.566,1.056-2.566,1.906 c0,1.152,1.936,2.087,4.324,2.087s4.324-0.934,4.324-2.087c0-1.152-1.936-2.086-4.324-2.086c-0.456,0-0.896,0.034-1.309,0.098 l-1.821-2.14c6.354-1.275,12.19-3.152,17.203-5.571c0.352-0.17,0.698-0.342,1.04-0.516l3.311,1.497 c-0.63,0.362-1.01,0.83-1.01,1.34c0,1.152,1.936,2.086,4.324,2.086s4.324-0.934,4.324-2.086c0-1.152-1.936-2.086-4.324-2.086 c-1.158,0-2.209,0.22-2.986,0.578l-3.311-1.497c4.814-2.497,8.49-5.379,10.9-8.498l4.23,0.751 c-0.123,0.193-0.189,0.398-0.189,0.611c0,1.152,1.936,2.086,4.324,2.086s4.324-0.934,4.324-2.086 c0-1.152-1.936-2.086-4.324-2.086c-1.778,0-3.305,0.518-3.969,1.258l-4.231-0.752c2.086-2.777,3.173-5.737,3.173-8.778 c0-0.24-0.008-0.48-0.021-0.719l5.064-0.079c0.185,1.07,2.042,1.911,4.308,1.911 C755.718,523.141,757.654,522.207,757.654,521.055z M739.451,530.567l-14.032-2.493c1.417-1.888,2.191-3.924,2.191-6.045 c0-0.155-0.004-0.309-0.012-0.463l14.919-0.234c0.013,0.232,0.02,0.464,0.02,0.697 C742.537,524.987,741.479,527.866,739.451,530.567z M726.889,522.029c0,2.079-0.758,4.074-2.146,5.925l-31.248-5.551 c0.056-0.097,0.091-0.199,0.102-0.304l33.281-0.522C726.885,521.727,726.889,521.878,726.889,522.029z M654.497,522.029 c0-2.079,0.758-4.074,2.146-5.925l31.248,5.551c-0.056,0.097-0.091,0.199-0.102,0.304l-33.281,0.522 C654.501,522.33,654.497,522.18,654.497,522.029z M693.329,522.621l31.247,5.551c-1.665,2.131-4.17,4.065-7.32,5.708 L692.971,522.9C693.112,522.814,693.232,522.721,693.329,522.621z M716.928,534.049c-3.432,1.743-7.601,3.146-12.263,4.09 l-12.649-14.861c0.228-0.056,0.439-0.126,0.627-0.209L716.928,534.049z M704.22,538.227c-3.766,0.735-7.845,1.172-12.111,1.252 l-1.082-16.056c0.187-0.01,0.37-0.029,0.544-0.056L704.22,538.227z M691.629,539.487c-0.311,0.004-0.623,0.006-0.936,0.006 c-4.132,0-8.104-0.337-11.806-0.955l11.069-15.152c0.19,0.024,0.388,0.039,0.591,0.044L691.629,539.487z M678.434,538.461 c-4.604-0.802-8.777-2.043-12.302-3.616l22.755-11.717c0.188,0.072,0.394,0.133,0.616,0.181L678.434,538.461z M665.781,534.687 c-3.243-1.487-5.916-3.26-7.846-5.234l30.228-6.733c0.106,0.09,0.231,0.174,0.373,0.25L665.781,534.687z M657.732,529.243 c-1.892-2.004-3.018-4.21-3.205-6.531l33.278-0.522c0.026,0.111,0.079,0.218,0.156,0.32L657.732,529.243z M656.81,515.886 c1.665-2.131,4.17-4.065,7.32-5.708l24.007,10.854l0.198,0.176c-0.107,0.072-0.201,0.148-0.279,0.229L656.81,515.886z  M664.458,510.009c2.316-1.176,4.969-2.197,7.881-3.027l15.072,13.404L664.458,510.009z M673.173,506.752 c1.147-0.307,2.33-0.586,3.549-0.833l12.649,14.861c-0.111,0.027-0.218,0.058-0.32,0.092L673.173,506.752z M677.166,505.831 c3.766-0.735,7.845-1.172,12.111-1.252l1.082,16.056c-0.188,0.01-0.37,0.029-0.545,0.056L677.166,505.831z M702.498,505.52 l-11.069,15.152c-0.19-0.024-0.388-0.039-0.591-0.044l-1.082-16.057c0.311-0.004,0.623-0.006,0.936-0.006 C694.825,504.565,698.797,504.902,702.498,505.52z M702.952,505.597c1.826,0.318,3.585,0.705,5.262,1.155l-15.877,14.12 c-0.142-0.047-0.294-0.088-0.453-0.123L702.952,505.597z M709.047,506.982c2.233,0.637,4.313,1.385,6.206,2.231l-20.7,10.658 L709.047,506.982z M715.605,509.371c3.243,1.487,5.916,3.26,7.846,5.234l-30.228,6.733c-0.052-0.045-0.11-0.088-0.172-0.129 l0.598-0.532L715.605,509.371z M723.654,514.815c1.892,2.004,3.018,4.21,3.205,6.531l-33.278,0.522 c-0.026-0.111-0.079-0.218-0.156-0.32L723.654,514.815z M672.829,506.446l-7.134-6.344c1.646-0.438,3.339-0.832,5.071-1.18 l5.682,6.675C675.205,505.849,673.998,506.133,672.829,506.446z M671.211,498.835c5.528-1.081,11.45-1.695,17.558-1.802 l0.485,7.2c-4.354,0.081-8.518,0.527-12.362,1.277L671.211,498.835z M689.249,497.025c0.48-0.006,0.962-0.01,1.444-0.01 c5.883,0,11.616,0.47,17.015,1.372l-4.971,6.804c-3.777-0.631-7.829-0.974-12.045-0.974c-0.321,0-0.641,0.002-0.959,0.006 L689.249,497.025z M708.162,498.464c2.595,0.447,5.112,0.994,7.529,1.638l-7.134,6.344c-1.711-0.458-3.503-0.853-5.366-1.177 L708.162,498.464z M728.688,539.048l-10.907-4.931c3.215-1.676,5.772-3.65,7.471-5.825l14.034,2.493 C736.942,533.817,733.369,536.62,728.688,539.048z M710.62,545.135l-5.681-6.675c4.758-0.964,9.013-2.395,12.515-4.174 l10.905,4.93c-0.331,0.168-0.666,0.335-1.007,0.5C722.476,542.069,716.8,543.895,710.62,545.135z M692.617,547.026l-0.485-7.2 c4.354-0.081,8.518-0.527,12.361-1.278l5.682,6.675C704.647,546.304,698.725,546.919,692.617,547.026z M673.677,545.67 l4.971-6.804c3.777,0.631,7.829,0.974,12.045,0.974c0.321,0,0.64-0.002,0.959-0.006l0.485,7.198 c-0.48,0.006-0.962,0.01-1.444,0.01C684.81,547.043,679.077,546.573,673.677,545.67z M655.419,540.361l10.22-5.262 c3.597,1.606,7.856,2.872,12.555,3.691l-4.971,6.805C666.678,544.466,660.632,542.7,655.419,540.361z M643.7,532.623 l13.581-3.025c1.969,2.015,4.697,3.825,8.008,5.342l-10.219,5.262c-0.349-0.159-0.694-0.321-1.036-0.486 C649.697,537.624,646.224,535.226,643.7,532.623z M638.884,522.957l14.922-0.234c0.189,2.368,1.339,4.62,3.271,6.665 l-13.58,3.025C640.712,529.47,639.133,526.27,638.884,522.957z M641.935,513.491l14.032,2.493 c-1.417,1.888-2.191,3.924-2.191,6.045c0,0.155,0.004,0.309,0.012,0.463l-14.919,0.234c-0.013-0.232-0.02-0.464-0.02-0.697 C638.849,519.071,639.907,516.192,641.935,513.491z M652.698,505.01l10.907,4.931c-3.215,1.676-5.772,3.65-7.471,5.825 l-14.034-2.493C644.444,510.241,648.018,507.438,652.698,505.01z M664.859,500.33l7.136,6.346 c-2.98,0.848-5.694,1.892-8.063,3.095l-10.905-4.93c0.331-0.168,0.666-0.335,1.007-0.5 C657.311,502.761,660.949,501.418,664.859,500.33z M716.379,499.491c-2.484-0.661-5.07-1.224-7.737-1.683l1.547-2.117 c0.436,0.071,0.902,0.11,1.387,0.11c2.388,0,4.324-0.934,4.324-2.086c0-1.152-1.936-2.086-4.324-2.086 c-2.388,0-4.324,0.934-4.324,2.086c0,0.836,1.019,1.557,2.491,1.89l-1.554,2.127c-5.552-0.928-11.446-1.411-17.495-1.411 c-0.498,0-0.995,0.004-1.491,0.01l-0.147-2.188c2.21-0.093,3.944-0.988,3.944-2.078c0-1.152-1.936-2.087-4.324-2.087 s-4.325,0.934-4.325,2.087c0,1.136,1.883,2.06,4.224,2.085l0.147,2.188c-6.282,0.109-12.373,0.742-18.059,1.854l-1.817-2.134 c1.512-0.325,2.566-1.056,2.566-1.906c0-1.152-1.936-2.086-4.325-2.086s-4.324,0.934-4.324,2.086s1.936,2.086,4.324,2.086 c0.457,0,0.896-0.034,1.31-0.098l1.821,2.139c-1.78,0.357-3.519,0.762-5.211,1.212l-25.818-22.96h103.008L716.379,499.491z  M725.967,503.697l-10.22,5.263c-1.938-0.865-4.068-1.632-6.355-2.283l7.136-6.346 C719.894,501.267,723.06,502.393,725.967,503.697z M737.686,511.435l-13.581,3.025c-1.969-2.015-4.697-3.825-8.007-5.342 l10.219-5.262c0.349,0.159,0.694,0.321,1.036,0.486C731.689,506.434,735.162,508.832,737.686,511.435z M742.502,521.1 l-14.922,0.234c-0.189-2.368-1.339-4.62-3.271-6.665l13.58-3.025C740.674,514.588,742.253,517.788,742.502,521.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 763.767,
    y: 466.314,
    style: {
      fill: "#95A9A7"
    },
    width: 55.568,
    height: 39.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.203,
    y: 466.535,
    style: {
      fill: "#95A9A7"
    },
    width: 55.568,
    height: 23.788
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.707,
    y: 473.855,
    style: {
      fill: "#95A9A7"
    },
    width: 31.172,
    height: 19.963
  }), /*#__PURE__*/React.createElement("rect", {
    x: 791.551,
    y: 466.314,
    style: {
      fill: "#95A9A7"
    },
    width: 39.304,
    height: 76.64
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#95A9A7"
    },
    points: "895.572,466.314 843.731,466.314 843.731,511.066 883.035,511.066  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 872.87,
    y: 466.314,
    style: {
      fill: "#95A9A7"
    },
    width: 45.403,
    height: 10.216
  }), /*#__PURE__*/React.createElement("rect", {
    x: 820.69,
    y: 538.139,
    style: {
      fill: "#95A9A7"
    },
    width: 1.355,
    height: 20.827
  }), /*#__PURE__*/React.createElement("rect", {
    x: 825.265,
    y: 533.67,
    style: {
      fill: "#95A9A7"
    },
    width: 1.355,
    height: 20.827
  }), /*#__PURE__*/React.createElement("rect", {
    x: 816.54,
    y: 530.795,
    style: {
      fill: "#95A9A7"
    },
    width: 1.355,
    height: 20.827
  }), /*#__PURE__*/React.createElement("rect", {
    x: 845.764,
    y: 507.633,
    style: {
      fill: "#95A9A7"
    },
    width: 18.551,
    height: 7.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 847.797,
    y: 513.234,
    style: {
      fill: "#95A9A7"
    },
    width: 14.485,
    height: 3.963
  }), /*#__PURE__*/React.createElement("rect", {
    x: 871.684,
    y: 509.772,
    style: {
      fill: "#95A9A7"
    },
    width: 3.558,
    height: 2.847
  }), /*#__PURE__*/React.createElement("rect", {
    x: 876.501,
    y: 509.772,
    style: {
      fill: "#95A9A7"
    },
    width: 5.082,
    height: 5.444
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 595.55,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 47.119,
    height: 73.279
  }), /*#__PURE__*/React.createElement("rect", {
    x: 592.03,
    y: 524.489,
    style: {
      fill: "#658280"
    },
    width: 54.16,
    height: 0.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.495,
    y: 514.198,
    style: {
      fill: "#658280"
    },
    width: 51.229,
    height: 0.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.495,
    y: 504.23,
    style: {
      fill: "#658280"
    },
    width: 51.229,
    height: 0.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.495,
    y: 494.262,
    style: {
      fill: "#658280"
    },
    width: 51.229,
    height: 0.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.495,
    y: 484.293,
    style: {
      fill: "#658280"
    },
    width: 51.229,
    height: 0.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.495,
    y: 474.324,
    style: {
      fill: "#658280"
    },
    width: 51.229,
    height: 0.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.495,
    y: 464.356,
    style: {
      fill: "#658280"
    },
    width: 51.229,
    height: 0.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 590.239,
    y: 525.232,
    style: {
      fill: "#658280"
    },
    width: 57.742,
    height: 2.025
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.791,
    y: 516.228,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.742,
    y: 516.228,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.693,
    y: 516.228,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.643,
    y: 516.228,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.791,
    y: 506.657,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.742,
    y: 506.657,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.693,
    y: 506.657,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.643,
    y: 506.657,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.791,
    y: 496.689,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.742,
    y: 496.689,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.693,
    y: 496.689,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.643,
    y: 496.689,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.791,
    y: 486.72,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.742,
    y: 486.72,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.693,
    y: 486.72,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.643,
    y: 486.72,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.791,
    y: 476.752,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.742,
    y: 476.752,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.693,
    y: 476.752,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.643,
    y: 476.752,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.791,
    y: 466.783,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.742,
    y: 466.783,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.693,
    y: 466.783,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.643,
    y: 466.783,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.791,
    y: 456.815,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.742,
    y: 456.815,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.693,
    y: 456.815,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.643,
    y: 456.815,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 4.896,
    height: 5.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.524,
    y: 526.244,
    style: {
      fill: "#658280"
    },
    width: 16.026,
    height: 3.806
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597.437,
    y: 529.508,
    style: {
      fill: "#658280"
    },
    width: 18.2,
    height: 0.65
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#658280"
    },
    points: "528.016,452.388 465.249,452.388 465.249,522.013 528.016,529.42  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.491,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 5.515,
    height: 70.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.183,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 5.515,
    height: 72.847
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.875,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 5.515,
    height: 74.92
  }), /*#__PURE__*/React.createElement("rect", {
    x: 509.566,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 5.515,
    height: 76.61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.258,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 5.515,
    height: 78.407
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.434,
    y: 511.912,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.126,
    y: 511.912,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.818,
    y: 511.912,
    style: {
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.51,
    y: 511.912,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.434,
    y: 502.543,
    style: {
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.126,
    y: 502.543,
    style: {
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.818,
    y: 502.543,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.51,
    y: 502.543,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.434,
    y: 493.173,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.126,
    y: 493.173,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.818,
    y: 493.173,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.51,
    y: 493.173,
    style: {
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.434,
    y: 483.804,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.126,
    y: 483.804,
    style: {
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.818,
    y: 483.804,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.51,
    y: 483.804,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.434,
    y: 474.435,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.126,
    y: 474.435,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.818,
    y: 474.435,
    style: {
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.51,
    y: 474.435,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.434,
    y: 465.066,
    style: {
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.126,
    y: 465.066,
    style: {
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.818,
    y: 465.066,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.51,
    y: 465.066,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.434,
    y: 455.697,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.126,
    y: 455.697,
    style: {
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.818,
    y: 455.697,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.51,
    y: 455.697,
    style: {
      fill: "#658280"
    },
    width: 7.32,
    height: 5.38
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#658280"
    },
    points: "286.197,518.677 286.197,517.954 284.705,517.954 284.705,515.894 310.968,515.894  310.968,452.388 267.87,452.388 267.87,512.581 267.87,515.894 267.87,517.954 266.306,517.954 266.306,518.677  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.618,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 36.916,
    height: 37.443
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 198.721,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 30.008,
    height: 46.026
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.785,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 32.701,
    height: 36.436
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.517,
    y: 494.753,
    style: {
      fill: "#658280"
    },
    width: 13.268,
    height: 5.508
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.029,
    y: 488.077,
    style: {
      fill: "#658280"
    },
    width: 34.859,
    height: 1.347
  })), /*#__PURE__*/React.createElement("rect", {
    x: 251.974,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 36.663,
    height: 20.808
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.48,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 29.823,
    height: 37.734
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.6,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 39.234,
    height: 18.93
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.398,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 24.541,
    height: 22.023
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.175,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 58.003,
    height: 6.898
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.18,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 29.728,
    height: 9.128
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.303,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 46.214,
    height: 13.927
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.867,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 71.987,
    height: 5.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.498,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 71.987,
    height: 5.999
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#658280"
    },
    points: "368.051,476 340.69,476 329.119,455.387 368.051,455.387  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.697,
    y: 483.126,
    style: {
      fill: "#658280"
    },
    width: 0.762,
    height: 22.867
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.509,
    y: 484.762,
    style: {
      fill: "#658280"
    },
    width: 1.016,
    height: 13.493
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.062,
    y: 489.185,
    style: {
      fill: "#658280"
    },
    width: 13.843,
    height: 6.679
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.725,
    y: 495.784,
    style: {
      fill: "#658280"
    },
    width: 18.334,
    height: 0.598
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.82,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 44.729,
    height: 19.313
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.995,
    y: 455.697,
    style: {
      fill: "#658280"
    },
    width: 28.737,
    height: 37.264
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.227,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 45.912,
    height: 33.568
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523.83,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 52.346,
    height: 12.369
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.598,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 34.04,
    height: 4.427
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.027,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 55.344,
    height: 12.369
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 656.076,
    y: 452.388,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1381.0188 949.5275)",
    style: {
      fill: "#658280"
    },
    width: 68.867,
    height: 44.752
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654.297,
    y: 497.14,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1383.2576 995.9964)",
    style: {
      fill: "#658280"
    },
    width: 74.664,
    height: 1.717
  }), /*#__PURE__*/React.createElement("rect", {
    x: 691.629,
    y: 494.443,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1413.5223 997.9581)",
    style: {
      fill: "#658280"
    },
    width: 30.265,
    height: 9.073
  }), /*#__PURE__*/React.createElement("rect", {
    x: 676.66,
    y: 497.998,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1358.4019 1001.5138)",
    style: {
      fill: "#658280"
    },
    width: 5.082,
    height: 5.517
  }), /*#__PURE__*/React.createElement("rect", {
    x: 665.987,
    y: 497.998,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1337.5638 1001.5138)",
    style: {
      fill: "#658280"
    },
    width: 5.591,
    height: 5.517
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 772.285,
    y: 452.388,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1599.0825 970.1339)",
    style: {
      fill: "#658280"
    },
    width: 54.513,
    height: 65.359
  }), /*#__PURE__*/React.createElement("rect", {
    x: 770.736,
    y: 517.023,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1599.0825 1035.8929)",
    style: {
      fill: "#658280"
    },
    width: 57.611,
    height: 1.847
  }), /*#__PURE__*/React.createElement("rect", {
    x: 774.117,
    y: 512.454,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1599.0825 1033.689)",
    style: {
      fill: "#658280"
    },
    width: 50.848,
    height: 8.781
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800.938,
    y: 515.234,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1622.0109 1040.0614)",
    style: {
      fill: "#658280"
    },
    width: 20.135,
    height: 9.594
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#658280"
    },
    points: "809.421,522.124 821.073,522.124 821.073,527.174 812.715,527.174  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 815.247,
    y: 520.117,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1631.6232 1051.4824)",
    style: {
      fill: "#658280"
    },
    width: 1.13,
    height: 11.249
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#658280"
    },
    d: "M814.797,531.949c0-0.322,0.454-0.583,1.014-0.583s1.015,0.261,1.015,0.583 c0,0.322-0.454,0.583-1.015,0.583S814.797,532.271,814.797,531.949z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 819.335,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 24.396,
    height: 26.982
  }), /*#__PURE__*/React.createElement("rect", {
    x: 749.844,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 27.822,
    height: 40.137
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#658280"
    },
    points: "763.767,452.388 724.576,452.388 724.576,473.855 757.654,466.783  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 835.72,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 59.852,
    height: 11.659
  }), /*#__PURE__*/React.createElement("rect", {
    x: 873.463,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 34.767,
    height: 46.541
  }), /*#__PURE__*/React.createElement("rect", {
    x: 900.098,
    y: 452.388,
    style: {
      fill: "#658280"
    },
    width: 57.601,
    height: 8.69
  }), /*#__PURE__*/React.createElement("rect", {
    x: 871.684,
    y: 498.254,
    style: {
      fill: "#658280"
    },
    width: 38.138,
    height: 1.526
  }), /*#__PURE__*/React.createElement("rect", {
    x: 902.808,
    y: 496.968,
    style: {
      fill: "#658280"
    },
    width: 0.762,
    height: 9.379
  }), /*#__PURE__*/React.createElement("rect", {
    x: 897.726,
    y: 497.636,
    style: {
      fill: "#658280"
    },
    width: 0.762,
    height: 7.524
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#658280"
    },
    points: "921.105,481.395 905.604,481.395 905.604,460.072 927.713,460.072  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Object"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 292.266,
    y: 252.295,
    style: {
      fill: "#B5C3C2"
    },
    width: 40.399,
    height: 160.805
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.867,
    y: 240.767,
    style: {
      fill: "#B5C3C2"
    },
    width: 27.197,
    height: 67.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.923,
    y: 233.454,
    style: {
      fill: "#B5C3C2"
    },
    width: 15.086,
    height: 37.483
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5C3C2"
    },
    points: "317.606,252.715 307.325,252.715 307.325,227.171 311.034,227.171 314.709,227.171  317.606,227.171  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5C3C2"
    },
    points: "311.788,241.591 310.673,241.591 310.673,216.047 311.076,216.047 311.474,216.047  311.788,216.047  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5C3C2"
    },
    points: "314.258,232.761 313.143,232.761 313.143,207.217 313.545,207.217 313.944,207.217  314.258,207.217  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 291.188,
    y: 251.883,
    style: {
      fill: "#B5C3C2"
    },
    width: 42.554,
    height: 1.712
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.875,
    y: 239.943,
    style: {
      fill: "#B5C3C2"
    },
    width: 29.182,
    height: 1.649
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.823,
    y: 232.761,
    style: {
      fill: "#B5C3C2"
    },
    width: 16.817,
    height: 1.265
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.368,
    y: 243.509,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 1.264,
    height: 7.081
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.866,
    y: 243.509,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 1.265,
    height: 7.081
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.365,
    y: 243.509,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 1.265,
    height: 7.081
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.863,
    y: 243.509,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 1.265,
    height: 7.081
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.361,
    y: 243.509,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 1.265,
    height: 7.081
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.86,
    y: 243.509,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 1.265,
    height: 7.081
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.358,
    y: 243.509,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 1.265,
    height: 7.081
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 258.707,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 258.707,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 258.707,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 258.707,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 258.707,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 258.707,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 271.801,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 271.801,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 271.801,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 271.801,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 271.801,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 271.801,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 284.896,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 284.896,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 284.896,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 284.896,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 284.896,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 284.896,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 297.99,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 297.99,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 297.99,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 297.99,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 297.99,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 297.99,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 311.085,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 311.085,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 311.085,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 311.085,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 311.085,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 311.085,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 324.18,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 324.18,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 324.18,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 324.18,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 324.18,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 324.18,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 337.274,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 337.274,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 337.274,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 337.274,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 337.274,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 337.274,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 350.369,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 350.369,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 350.369,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 350.369,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 350.369,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 350.369,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 363.463,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 363.463,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 363.463,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 363.463,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 363.463,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 363.463,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 376.558,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 376.558,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 376.558,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 376.558,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 376.558,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 376.558,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.812,
    y: 389.652,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.862,
    y: 389.652,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.913,
    y: 389.652,
    style: {
      opacity: 0.29,
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.963,
    y: 389.652,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.014,
    y: 389.652,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.064,
    y: 389.652,
    style: {
      fill: "#B5C3C2"
    },
    width: 3.055,
    height: 8.401
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 174.937,
    y: 258.412,
    style: {
      fill: "#B5C3C2"
    },
    width: 64.942,
    height: 135.464
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.092,
    y: 256.082,
    style: {
      fill: "#B5C3C2"
    },
    width: 68.633,
    height: 3.829
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.12,
    y: 251.182,
    style: {
      fill: "#B5C3C2"
    },
    width: 60.576,
    height: 18.199
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.757,
    y: 243.735,
    style: {
      fill: "#B5C3C2"
    },
    width: 23.988,
    height: 19.884
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5C3C2"
    },
    points: "195.639,249.339 181.757,249.339 181.757,238.872 191.713,238.872  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.352,
    y: 230.184,
    style: {
      fill: "#B5C3C2"
    },
    width: 1.346,
    height: 23.315
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5C3C2"
    },
    d: "M189.233,228.975c0,0.667-0.541,1.208-1.209,1.208c-0.667,0-1.209-0.541-1.209-1.208 c0-0.667,0.541-1.209,1.209-1.209C188.692,227.767,189.233,228.308,189.233,228.975z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5C3C2"
    },
    points: "777.666,404.188 706.578,404.188 697.707,205.019 777.666,221.617  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5C3C2"
    },
    points: "467.521,290.445 467.521,223.858 456.372,223.858 456.372,206.022 452.389,206.022  452.389,179.862 430.445,179.862 430.445,160.637 428.492,160.637 428.492,179.862 424.193,179.862 424.193,155.796  422.241,155.796 422.241,179.862 408.368,179.862 408.368,223.858 401.202,223.858 401.202,290.445 395.059,290.445  395.059,411.728 471.84,411.728 471.84,290.445  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 84.175,
    y: 401.719,
    style: {
      fill: "#B5C3C2"
    },
    width: 849.37,
    height: 20.201
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#95A9A7"
    },
    points: "584.14,416.97 546.529,416.97 561.184,341.655 584.14,341.655  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.701,
    y: 419.904,
    style: {
      fill: "#95A9A7"
    },
    width: 891.8,
    height: 31.853
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#95A9A7"
    },
    points: "553.317,277.6 553.317,244.226 541.241,244.226 541.241,231.52 534.78,231.52  534.78,220.846 532.513,220.846 532.513,202.55 531.927,202.55 531.927,220.846 529.659,220.846 529.659,231.52 523.198,231.52  523.198,244.226 511.214,244.226 511.214,277.6 508.723,277.6 508.723,338.192 490.142,338.192 490.142,407.264 508.723,407.264  527.305,407.264 555.716,407.264 555.716,277.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#95A9A7"
    },
    points: "622.722,315.937 564.268,315.937 564.268,317 566.913,317 566.913,415.841  620.077,415.841 620.077,317 622.722,317  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.346,
    y: 340.557,
    style: {
      fill: "#95A9A7"
    },
    width: 51.826,
    height: 82.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.408,
    y: 382.741,
    style: {
      fill: "#95A9A7"
    },
    width: 89.132,
    height: 40.151
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.183,
    y: 293.036,
    style: {
      fill: "#95A9A7"
    },
    width: 19.567,
    height: 98.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.503,
    y: 266.734,
    style: {
      fill: "#95A9A7"
    },
    width: 1.016,
    height: 53.62
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.807,
    y: 270.8,
    style: {
      fill: "#95A9A7"
    },
    width: 1.016,
    height: 53.62
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.692,
    y: 286.937,
    style: {
      fill: "#95A9A7"
    },
    width: 11.96,
    height: 13.214
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.047,
    y: 355.296,
    style: {
      fill: "#95A9A7"
    },
    width: 34.052,
    height: 67.596
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.573,
    y: 283.762,
    style: {
      fill: "#95A9A7"
    },
    width: 63.921,
    height: 139.13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.853,
    y: 278.98,
    style: {
      fill: "#95A9A7"
    },
    width: 51.361,
    height: 23.173
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.618,
    y: 286.673,
    style: {
      fill: "#95A9A7"
    },
    width: 73.831,
    height: 1.627
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.992,
    y: 352.628,
    style: {
      fill: "#95A9A7"
    },
    width: 30.119,
    height: 70.265
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.27,
    y: 349.959,
    style: {
      fill: "#95A9A7"
    },
    width: 34.561,
    height: 72.933
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 148.452,
    y: 330.138,
    style: {
      fill: "#95A9A7"
    },
    width: 68.867,
    height: 92.755
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.434,
    y: 326.58,
    style: {
      fill: "#95A9A7"
    },
    width: 74.664,
    height: 3.558
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.501,
    y: 316.923,
    style: {
      fill: "#95A9A7"
    },
    width: 30.265,
    height: 18.805
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.652,
    y: 316.923,
    style: {
      fill: "#95A9A7"
    },
    width: 5.082,
    height: 11.436
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.817,
    y: 316.923,
    style: {
      fill: "#95A9A7"
    },
    width: 5.591,
    height: 11.436
  })), /*#__PURE__*/React.createElement("rect", {
    x: 118.465,
    y: 394.685,
    style: {
      fill: "#95A9A7"
    },
    width: 36.085,
    height: 28.208
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.835,
    y: 382.741,
    style: {
      fill: "#95A9A7"
    },
    width: 17.087,
    height: 40.151
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.175,
    y: 408.789,
    style: {
      fill: "#95A9A7"
    },
    width: 29.204,
    height: 14.104
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.215,
    y: 391.635,
    style: {
      fill: "#95A9A7"
    },
    width: 359.849,
    height: 31.257
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A9A7"
    },
    d: "M753.33,305.111c-2.266,0-4.123,1.743-4.308,3.961l-5.064-0.165 c0.013-0.496,0.021-0.993,0.021-1.491c0-6.303-1.088-12.439-3.173-18.194l4.231-1.558c0.665,1.534,2.191,2.607,3.969,2.607 c2.388,0,4.324-1.936,4.324-4.324c0-2.388-1.936-4.324-4.324-4.324s-4.324,1.936-4.324,4.324c0,0.441,0.066,0.866,0.189,1.267 l-4.23,1.557c-2.41-6.465-6.085-12.439-10.9-17.614l3.311-3.102c0.776,0.742,1.827,1.198,2.986,1.198 c2.388,0,4.324-1.936,4.324-4.324c0-2.388-1.936-4.324-4.324-4.324s-4.324,1.936-4.324,4.324c0,1.057,0.38,2.025,1.01,2.777 l-3.311,3.103c-0.341-0.36-0.687-0.717-1.04-1.069c-5.013-5.013-10.849-8.904-17.203-11.547l1.821-4.434 c0.413,0.131,0.853,0.202,1.309,0.202c2.388,0,4.324-1.936,4.324-4.324c0-2.388-1.936-4.324-4.324-4.324 s-4.324,1.936-4.324,4.324c0,1.762,1.054,3.277,2.566,3.951l-1.817,4.424c-5.685-2.304-11.777-3.615-18.059-3.842l0.197-6.061 c0.046,0.001,0.091,0.003,0.137,0.003c2.388,0,4.324-1.936,4.324-4.324s-1.936-4.324-4.324-4.324s-4.324,1.936-4.324,4.324 c0,2.179,1.612,3.98,3.708,4.28l-0.198,6.087c-0.496-0.014-0.993-0.021-1.491-0.021c-6.049,0-11.943,1.002-17.495,2.925 l-1.744-4.947c1.573-0.647,2.68-2.194,2.68-4c0-2.388-1.936-4.324-4.324-4.324s-4.325,1.936-4.325,4.324s1.936,4.324,4.325,4.324 c0.413,0,0.812-0.059,1.19-0.167l1.744,4.948c-6.733,2.402-12.95,6.167-18.311,11.154l-3.16-3.372 c0.707-0.77,1.139-1.796,1.139-2.924c0-2.388-1.936-4.324-4.324-4.324s-4.325,1.936-4.325,4.324c0,2.388,1.936,4.324,4.325,4.324 c1.088,0,2.081-0.403,2.841-1.066l3.155,3.367c-0.36,0.341-0.717,0.687-1.069,1.039c-4.459,4.459-8.029,9.569-10.624,15.116 L638.374,283c0.145-0.433,0.225-0.896,0.225-1.378c0-2.388-1.936-4.324-4.324-4.324c-2.388,0-4.324,1.936-4.324,4.324 s1.936,4.324,4.324,4.324c1.736,0,3.233-1.024,3.921-2.5l3.992,1.843c-2.866,6.274-4.49,13.094-4.745,20.156l-5.155-0.168 c-0.064-2.333-1.973-4.204-4.321-4.204c-2.388,0-4.324,1.936-4.324,4.324c0,2.388,1.936,4.324,4.324,4.324 c2.267,0,4.125-1.745,4.308-3.964l5.153,0.168c-0.014,0.496-0.021,0.993-0.021,1.491c0,6.303,1.088,12.439,3.173,18.194 l-4.231,1.558c-0.665-1.534-2.191-2.607-3.969-2.607c-2.388,0-4.324,1.936-4.324,4.324c0,2.388,1.936,4.324,4.324,4.324 s4.325-1.936,4.325-4.324c0-0.441-0.066-0.866-0.189-1.267l4.23-1.558c2.41,6.465,6.085,12.439,10.9,17.614l-3.311,3.102 c-0.776-0.741-1.827-1.198-2.986-1.198c-2.388,0-4.324,1.936-4.324,4.324c0,2.388,1.936,4.324,4.324,4.324 s4.325-1.936,4.325-4.324c0-1.057-0.38-2.025-1.01-2.777l3.311-3.102c0.341,0.36,0.687,0.717,1.039,1.069 c3.376,3.376,7.126,6.243,11.156,8.563l-26.075,48.061h-4.68v1.374h-2.292v2.729h119.137v-2.729h-2.292v-1.374h-4.68 l-26.075-48.061c3.474-2,6.739-4.406,9.737-7.194l4.225,4.509c-0.907,0.793-1.481,1.957-1.481,3.257 c0,2.388,1.936,4.324,4.324,4.324c2.388,0,4.325-1.936,4.325-4.324s-1.936-4.324-4.325-4.324c-0.916,0-1.764,0.285-2.463,0.771 l-4.255-4.541c0.36-0.341,0.717-0.687,1.069-1.039c4.459-4.459,8.029-9.569,10.625-15.116l4.706,2.172 c-0.085,0.339-0.131,0.694-0.131,1.059c0,2.388,1.936,4.324,4.324,4.324s4.324-1.936,4.324-4.324 c0-2.388-1.936-4.324-4.324-4.324c-1.853,0-3.433,1.165-4.048,2.803l-4.648-2.146c2.866-6.274,4.49-13.094,4.745-20.156 l5.066,0.165c0.062,2.334,1.972,4.207,4.321,4.207c2.388,0,4.325-1.936,4.325-4.324S755.718,305.111,753.33,305.111z  M742.537,307.417c0,0.482-0.007,0.964-0.02,1.444l-14.919-0.485c0.008-0.319,0.012-0.639,0.012-0.959 c0-4.397-0.774-8.616-2.191-12.53l14.032-5.166C741.479,295.319,742.537,301.286,742.537,307.417z M726.877,308.353 l-33.281-1.082c-0.011-0.217-0.046-0.428-0.102-0.63l31.248-11.505c1.388,3.836,2.146,7.971,2.146,12.281 C726.889,307.73,726.885,308.042,726.877,308.353z M654.509,306.481l33.281,1.082c0.011,0.217,0.046,0.428,0.102,0.63 l-31.248,11.505c-1.388-3.836-2.146-7.971-2.146-12.281C654.497,307.104,654.501,306.792,654.509,306.481z M692.971,305.611 l24.284-22.755c3.15,3.404,5.655,7.412,7.32,11.83l-31.247,11.504C693.232,305.983,693.112,305.789,692.971,305.611z  M692.643,305.26c-0.188-0.17-0.399-0.316-0.627-0.432l12.649-30.801c4.662,1.958,8.831,4.865,12.263,8.477L692.643,305.26z  M691.572,304.645c-0.175-0.055-0.357-0.094-0.544-0.116l1.082-33.278c4.266,0.165,8.345,1.071,12.111,2.594L691.572,304.645z  M690.547,304.513c-0.203,0.01-0.401,0.041-0.591,0.091l-11.069-31.405c3.702-1.281,7.674-1.979,11.806-1.979 c0.313,0,0.625,0.004,0.936,0.012L690.547,304.513z M689.503,304.764c-0.221,0.099-0.428,0.226-0.616,0.375l-22.755-24.284 c3.525-3.262,7.698-5.833,12.302-7.495L689.503,304.764z M688.537,305.467c-0.143,0.158-0.268,0.332-0.373,0.518l-30.228-13.954 c1.93-4.092,4.602-7.767,7.846-10.848L688.537,305.467z M687.961,306.42c-0.077,0.21-0.129,0.432-0.156,0.662l-33.278-1.082 c0.186-4.809,1.313-9.382,3.205-13.536L687.961,306.42z M688.057,308.643c0.078,0.167,0.171,0.326,0.279,0.474l-0.198,0.365 l-24.007,22.495c-3.15-3.404-5.655-7.412-7.32-11.83L688.057,308.643z M687.411,310.821l-15.072,27.781 c-2.912-1.72-5.565-3.835-7.881-6.273L687.411,310.821z M689.05,309.815c0.102,0.07,0.209,0.133,0.32,0.19l-12.649,30.801 c-1.218-0.512-2.402-1.089-3.549-1.726L689.05,309.815z M689.814,310.189c0.175,0.055,0.357,0.094,0.545,0.116l-1.082,33.278 c-4.266-0.165-8.345-1.071-12.111-2.594L689.814,310.189z M690.693,343.613c-0.313,0-0.625-0.004-0.936-0.012l1.082-33.281 c0.203-0.01,0.401-0.041,0.591-0.091l11.069,31.405C698.797,342.915,694.825,343.613,690.693,343.613z M691.883,310.069 c0.159-0.072,0.311-0.156,0.453-0.254l15.877,29.265c-1.677,0.932-3.435,1.735-5.262,2.394L691.883,310.069z M694.554,311.889 l20.7,22.091c-1.893,1.752-3.973,3.304-6.206,4.623L694.554,311.889z M693.649,310.22l-0.598-1.103 c0.062-0.086,0.12-0.175,0.172-0.268l30.228,13.954c-1.93,4.092-4.603,7.767-7.846,10.848L693.649,310.22z M693.425,308.414 c0.077-0.211,0.129-0.433,0.156-0.662l33.278,1.082c-0.186,4.81-1.313,9.382-3.205,13.536L693.425,308.414z M676.448,341.473 l-5.682,13.835c-1.732-0.721-3.424-1.537-5.071-2.445l7.134-13.149C673.998,340.363,675.205,340.952,676.448,341.473z  M676.892,341.655c3.844,1.555,8.007,2.48,12.362,2.648l-0.485,14.922c-6.108-0.221-12.03-1.496-17.558-3.736L676.892,341.655z  M689.734,344.321c0.319,0.008,0.638,0.012,0.959,0.012c4.216,0,8.268-0.712,12.045-2.02l4.971,14.102 c-5.4,1.87-11.133,2.844-17.015,2.844c-0.483,0-0.964-0.007-1.444-0.02L689.734,344.321z M703.191,342.154 c1.862-0.672,3.655-1.491,5.366-2.44l7.134,13.149c-2.417,1.334-4.933,2.469-7.529,3.395L703.191,342.154z M739.286,289.27 l-14.034,5.167c-1.699-4.509-4.256-8.599-7.471-12.073l10.907-10.22C733.369,277.176,736.942,282.984,739.286,289.27z  M727.352,270.758c0.341,0.341,0.676,0.687,1.007,1.036l-10.905,10.219c-3.503-3.688-7.757-6.654-12.515-8.652l5.681-13.835 C716.8,262.097,722.476,265.882,727.352,270.758z M710.175,259.344l-5.682,13.835c-3.844-1.555-8.007-2.48-12.361-2.648 l0.485-14.923C698.725,255.829,704.647,257.104,710.175,259.344z M690.693,255.573c0.482,0,0.964,0.007,1.444,0.02l-0.485,14.919 c-0.319-0.008-0.638-0.012-0.959-0.012c-4.216,0-8.268,0.712-12.045,2.02l-4.971-14.102 C679.077,256.547,684.81,255.573,690.693,255.573z M673.224,258.576l4.971,14.103c-4.699,1.696-8.958,4.32-12.555,7.649 l-10.22-10.907C660.632,264.573,666.678,260.913,673.224,258.576z M654.034,270.758c0.341-0.341,0.687-0.676,1.036-1.007 l10.219,10.905c-3.31,3.144-6.039,6.895-8.008,11.072l-13.581-6.269C646.224,280.064,649.697,275.094,654.034,270.758z  M643.498,285.895l13.58,6.269c-1.931,4.239-3.081,8.905-3.271,13.814l-14.922-0.485 C639.133,298.627,640.712,291.995,643.498,285.895z M638.849,307.417c0-0.482,0.007-0.964,0.02-1.444l14.919,0.485 c-0.008,0.319-0.012,0.638-0.012,0.959c0,4.397,0.774,8.616,2.191,12.53l-14.032,5.166 C639.907,319.515,638.849,313.547,638.849,307.417z M642.1,325.564l14.034-5.167c1.699,4.509,4.256,8.599,7.471,12.073 l-10.907,10.22C648.018,337.658,644.444,331.85,642.1,325.564z M654.034,344.076c-0.341-0.341-0.676-0.687-1.007-1.035 l10.905-10.219c2.369,2.494,5.083,4.657,8.063,6.415l-7.136,13.154C660.949,350.136,657.311,347.353,654.034,344.076z  M742.197,401.719H639.189l25.818-47.588c1.692,0.933,3.431,1.771,5.211,2.512l-1.821,4.434c-0.413-0.131-0.853-0.202-1.31-0.202 c-2.388,0-4.324,1.936-4.324,4.324s1.936,4.324,4.324,4.324s4.325-1.936,4.325-4.324c0-1.762-1.054-3.277-2.566-3.951 l1.817-4.424c5.685,2.304,11.777,3.615,18.059,3.842l-0.147,4.535c-2.342,0.053-4.224,1.967-4.224,4.322 c0,2.388,1.936,4.324,4.325,4.324s4.324-1.936,4.324-4.324c0-2.26-1.734-4.114-3.944-4.307l0.147-4.535 c0.496,0.014,0.993,0.021,1.491,0.021c6.049,0,11.943-1.002,17.495-2.925l1.554,4.409c-1.471,0.69-2.491,2.184-2.491,3.917 c0,2.388,1.936,4.324,4.324,4.324c2.388,0,4.324-1.936,4.324-4.324c0-2.388-1.936-4.324-4.324-4.324 c-0.485,0-0.952,0.081-1.387,0.229l-1.547-4.389c2.667-0.952,5.253-2.117,7.737-3.487L742.197,401.719z M716.528,352.39 l-7.136-13.154c2.287-1.349,4.417-2.938,6.355-4.731l10.22,10.907C723.06,348.115,719.894,350.449,716.528,352.39z  M727.352,344.076c-0.341,0.341-0.687,0.676-1.036,1.007l-10.219-10.905c3.31-3.144,6.038-6.895,8.007-11.072l13.581,6.269 C735.162,334.769,731.689,339.739,727.352,344.076z M737.888,328.939l-13.58-6.269c1.931-4.239,3.081-8.906,3.271-13.814 l14.922,0.485C742.253,316.207,740.674,322.839,737.888,328.939z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 763.767,
    y: 341.475,
    style: {
      fill: "#95A9A7"
    },
    width: 55.568,
    height: 81.418
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.203,
    y: 373.129,
    style: {
      fill: "#95A9A7"
    },
    width: 55.568,
    height: 49.304
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.707,
    y: 365.889,
    style: {
      fill: "#95A9A7"
    },
    width: 31.172,
    height: 41.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 791.551,
    y: 264.046,
    style: {
      fill: "#95A9A7"
    },
    width: 39.304,
    height: 158.846
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#95A9A7"
    },
    points: "895.572,422.892 843.731,422.892 843.731,330.138 883.035,330.138  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 872.87,
    y: 401.719,
    style: {
      fill: "#95A9A7"
    },
    width: 45.403,
    height: 21.174
  }), /*#__PURE__*/React.createElement("rect", {
    x: 820.69,
    y: 230.861,
    style: {
      fill: "#95A9A7"
    },
    width: 1.355,
    height: 43.166
  }), /*#__PURE__*/React.createElement("rect", {
    x: 825.265,
    y: 240.124,
    style: {
      fill: "#95A9A7"
    },
    width: 1.355,
    height: 43.166
  }), /*#__PURE__*/React.createElement("rect", {
    x: 816.54,
    y: 246.083,
    style: {
      fill: "#95A9A7"
    },
    width: 1.355,
    height: 43.166
  }), /*#__PURE__*/React.createElement("rect", {
    x: 845.764,
    y: 322.641,
    style: {
      fill: "#95A9A7"
    },
    width: 18.551,
    height: 14.612
  }), /*#__PURE__*/React.createElement("rect", {
    x: 847.797,
    y: 317.432,
    style: {
      fill: "#95A9A7"
    },
    width: 14.485,
    height: 8.213
  }), /*#__PURE__*/React.createElement("rect", {
    x: 871.684,
    y: 326.921,
    style: {
      fill: "#95A9A7"
    },
    width: 3.558,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 876.501,
    y: 321.538,
    style: {
      fill: "#95A9A7"
    },
    width: 5.082,
    height: 11.283
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 595.55,
    y: 299.878,
    style: {
      fill: "#658280"
    },
    width: 47.119,
    height: 151.879
  }), /*#__PURE__*/React.createElement("rect", {
    x: 592.03,
    y: 300.778,
    style: {
      fill: "#658280"
    },
    width: 54.16,
    height: 1.539
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.495,
    y: 322.112,
    style: {
      fill: "#658280"
    },
    width: 51.229,
    height: 1.534
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.495,
    y: 342.773,
    style: {
      fill: "#658280"
    },
    width: 51.229,
    height: 1.534
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.495,
    y: 363.434,
    style: {
      fill: "#658280"
    },
    width: 51.229,
    height: 1.534
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.495,
    y: 384.095,
    style: {
      fill: "#658280"
    },
    width: 51.229,
    height: 1.534
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.495,
    y: 404.756,
    style: {
      fill: "#658280"
    },
    width: 51.229,
    height: 1.534
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.495,
    y: 425.417,
    style: {
      fill: "#658280"
    },
    width: 51.229,
    height: 1.534
  }), /*#__PURE__*/React.createElement("rect", {
    x: 590.239,
    y: 296.582,
    style: {
      fill: "#658280"
    },
    width: 57.742,
    height: 4.196
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.791,
    y: 307.306,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.742,
    y: 307.306,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.693,
    y: 307.306,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.643,
    y: 307.306,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.791,
    y: 327.143,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.742,
    y: 327.143,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.693,
    y: 327.143,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.643,
    y: 327.143,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.791,
    y: 347.804,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.742,
    y: 347.804,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.693,
    y: 347.804,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.643,
    y: 347.804,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.791,
    y: 368.465,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.742,
    y: 368.465,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.693,
    y: 368.465,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.643,
    y: 368.465,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.791,
    y: 389.126,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.742,
    y: 389.126,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.693,
    y: 389.126,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.643,
    y: 389.126,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.791,
    y: 409.787,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.742,
    y: 409.787,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.693,
    y: 409.787,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.643,
    y: 409.787,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.791,
    y: 430.448,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.742,
    y: 430.448,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.693,
    y: 430.448,
    style: {
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.643,
    y: 430.448,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 4.896,
    height: 12.133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.524,
    y: 290.792,
    style: {
      fill: "#658280"
    },
    width: 16.026,
    height: 7.888
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597.437,
    y: 290.567,
    style: {
      fill: "#658280"
    },
    width: 18.2,
    height: 1.348
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#658280"
    },
    points: "528.016,451.757 465.249,451.757 465.249,307.451 528.016,292.098  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.491,
    y: 304.911,
    style: {
      fill: "#658280"
    },
    width: 5.515,
    height: 146.846
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.183,
    y: 300.773,
    style: {
      fill: "#658280"
    },
    width: 5.515,
    height: 150.984
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.875,
    y: 296.475,
    style: {
      fill: "#658280"
    },
    width: 5.515,
    height: 155.282
  }), /*#__PURE__*/React.createElement("rect", {
    x: 509.566,
    y: 292.973,
    style: {
      fill: "#658280"
    },
    width: 5.515,
    height: 158.784
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.258,
    y: 289.249,
    style: {
      fill: "#658280"
    },
    width: 5.515,
    height: 162.508
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.434,
    y: 317.234,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.126,
    y: 317.234,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.818,
    y: 317.234,
    style: {
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.51,
    y: 317.234,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.434,
    y: 336.653,
    style: {
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.126,
    y: 336.653,
    style: {
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.818,
    y: 336.653,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.51,
    y: 336.653,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.434,
    y: 356.072,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.126,
    y: 356.072,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.818,
    y: 356.072,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.51,
    y: 356.072,
    style: {
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.434,
    y: 375.491,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.126,
    y: 375.491,
    style: {
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.818,
    y: 375.491,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.51,
    y: 375.491,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.434,
    y: 394.909,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.126,
    y: 394.909,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.818,
    y: 394.909,
    style: {
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.51,
    y: 394.909,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.434,
    y: 414.328,
    style: {
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.126,
    y: 414.328,
    style: {
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.818,
    y: 414.328,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.51,
    y: 414.328,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.434,
    y: 433.746,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.126,
    y: 433.746,
    style: {
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.818,
    y: 433.746,
    style: {
      opacity: 0.29,
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.51,
    y: 433.746,
    style: {
      fill: "#658280"
    },
    width: 7.32,
    height: 11.152
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#658280"
    },
    points: "286.197,314.364 286.197,315.862 284.705,315.862 284.705,320.132 310.968,320.132  310.968,451.757 267.87,451.757 267.87,326.999 267.87,320.132 267.87,315.862 266.306,315.862 266.306,314.364  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.618,
    y: 374.152,
    style: {
      fill: "#658280"
    },
    width: 36.916,
    height: 77.605
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 198.721,
    y: 356.362,
    style: {
      fill: "#658280"
    },
    width: 30.008,
    height: 95.395
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.785,
    y: 376.238,
    style: {
      fill: "#658280"
    },
    width: 32.701,
    height: 75.519
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.517,
    y: 352.533,
    style: {
      fill: "#658280"
    },
    width: 13.268,
    height: 11.416
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.029,
    y: 374.994,
    style: {
      fill: "#658280"
    },
    width: 34.859,
    height: 2.792
  })), /*#__PURE__*/React.createElement("rect", {
    x: 251.974,
    y: 408.629,
    style: {
      fill: "#658280"
    },
    width: 36.663,
    height: 43.128
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.48,
    y: 373.549,
    style: {
      fill: "#658280"
    },
    width: 29.823,
    height: 78.208
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.6,
    y: 412.523,
    style: {
      fill: "#658280"
    },
    width: 39.234,
    height: 39.234
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.398,
    y: 406.111,
    style: {
      fill: "#658280"
    },
    width: 24.541,
    height: 45.646
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.175,
    y: 437.459,
    style: {
      fill: "#658280"
    },
    width: 58.003,
    height: 14.298
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.18,
    y: 432.838,
    style: {
      fill: "#658280"
    },
    width: 29.728,
    height: 18.919
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.303,
    y: 422.892,
    style: {
      fill: "#658280"
    },
    width: 46.214,
    height: 28.865
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.867,
    y: 439.322,
    style: {
      fill: "#658280"
    },
    width: 71.987,
    height: 12.435
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.498,
    y: 439.322,
    style: {
      fill: "#658280"
    },
    width: 71.987,
    height: 12.435
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#658280"
    },
    points: "368.051,402.817 340.69,402.817 329.119,445.54 368.051,445.54  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.697,
    y: 340.654,
    style: {
      fill: "#658280"
    },
    width: 0.762,
    height: 47.394
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.509,
    y: 356.692,
    style: {
      fill: "#658280"
    },
    width: 1.016,
    height: 27.965
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.062,
    y: 361.648,
    style: {
      fill: "#658280"
    },
    width: 13.843,
    height: 13.843
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.725,
    y: 360.572,
    style: {
      fill: "#658280"
    },
    width: 18.334,
    height: 1.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.82,
    y: 411.728,
    style: {
      fill: "#658280"
    },
    width: 44.729,
    height: 40.028
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.995,
    y: 367.664,
    style: {
      fill: "#658280"
    },
    width: 28.737,
    height: 77.235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.227,
    y: 382.184,
    style: {
      fill: "#658280"
    },
    width: 45.912,
    height: 69.573
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523.83,
    y: 426.121,
    style: {
      fill: "#658280"
    },
    width: 52.346,
    height: 25.636
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.598,
    y: 442.581,
    style: {
      fill: "#658280"
    },
    width: 34.04,
    height: 9.176
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.027,
    y: 426.121,
    style: {
      fill: "#658280"
    },
    width: 55.344,
    height: 25.636
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 656.076,
    y: 359.002,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1381.0188 810.7593)",
    style: {
      fill: "#658280"
    },
    width: 68.867,
    height: 92.755
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654.297,
    y: 355.444,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1383.2576 714.4468)",
    style: {
      fill: "#658280"
    },
    width: 74.664,
    height: 3.558
  }), /*#__PURE__*/React.createElement("rect", {
    x: 691.629,
    y: 345.788,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1413.5223 710.3808)",
    style: {
      fill: "#658280"
    },
    width: 30.265,
    height: 18.805
  }), /*#__PURE__*/React.createElement("rect", {
    x: 676.66,
    y: 345.788,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1358.4019 703.0113)",
    style: {
      fill: "#658280"
    },
    width: 5.082,
    height: 11.436
  }), /*#__PURE__*/React.createElement("rect", {
    x: 665.987,
    y: 345.788,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1337.5638 703.0113)",
    style: {
      fill: "#658280"
    },
    width: 5.591,
    height: 11.436
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 772.285,
    y: 316.293,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1599.0825 768.0501)",
    style: {
      fill: "#658280"
    },
    width: 54.513,
    height: 135.464
  }), /*#__PURE__*/React.createElement("rect", {
    x: 770.736,
    y: 313.964,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1599.0825 631.7564)",
    style: {
      fill: "#658280"
    },
    width: 57.611,
    height: 3.829
  }), /*#__PURE__*/React.createElement("rect", {
    x: 774.117,
    y: 309.063,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1599.0825 636.3243)",
    style: {
      fill: "#658280"
    },
    width: 50.848,
    height: 18.199
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800.938,
    y: 301.616,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1622.0109 623.1168)",
    style: {
      fill: "#658280"
    },
    width: 20.135,
    height: 19.884
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#658280"
    },
    points: "809.421,307.221 821.073,307.221 821.073,296.753 812.715,296.753  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 815.247,
    y: 288.065,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1631.6232 599.4452)",
    style: {
      fill: "#658280"
    },
    width: 1.13,
    height: 23.315
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#658280"
    },
    d: "M814.797,286.857c0,0.667,0.454,1.208,1.014,1.208s1.015-0.541,1.015-1.208 c0-0.668-0.454-1.209-1.015-1.209S814.797,286.189,814.797,286.857z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 819.335,
    y: 395.834,
    style: {
      fill: "#658280"
    },
    width: 24.396,
    height: 55.923
  }), /*#__PURE__*/React.createElement("rect", {
    x: 749.844,
    y: 368.569,
    style: {
      fill: "#658280"
    },
    width: 27.822,
    height: 83.188
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#658280"
    },
    points: "763.767,451.757 724.576,451.757 724.576,407.264 757.654,421.92  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 835.72,
    y: 427.593,
    style: {
      fill: "#658280"
    },
    width: 59.852,
    height: 24.164
  }), /*#__PURE__*/React.createElement("rect", {
    x: 873.463,
    y: 355.296,
    style: {
      fill: "#658280"
    },
    width: 34.767,
    height: 96.461
  }), /*#__PURE__*/React.createElement("rect", {
    x: 900.098,
    y: 433.746,
    style: {
      fill: "#658280"
    },
    width: 57.601,
    height: 18.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 871.684,
    y: 353.53,
    style: {
      fill: "#658280"
    },
    width: 38.138,
    height: 3.162
  }), /*#__PURE__*/React.createElement("rect", {
    x: 902.808,
    y: 339.919,
    style: {
      fill: "#658280"
    },
    width: 0.762,
    height: 19.439
  }), /*#__PURE__*/React.createElement("rect", {
    x: 897.726,
    y: 342.38,
    style: {
      fill: "#658280"
    },
    width: 0.762,
    height: 15.594
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#658280"
    },
    points: "921.105,391.635 905.604,391.635 905.604,435.83 927.713,435.83  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.52
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.817,
    y: 361.192,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.271,
    height: 2.271
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.381,
    y: 361.192,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.271,
    height: 2.271
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.817,
    y: 366.528,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.271,
    height: 2.271
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.381,
    y: 366.528,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.271,
    height: 2.271
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.817,
    y: 371.687,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.271,
    height: 2.271
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.453,
    y: 361.192,
    style: {
      fill: "#FFFFFF"
    },
    width: 2.271,
    height: 2.271
  })), /*#__PURE__*/React.createElement("rect", {
    x: 368.051,
    y: 292.973,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.39,
    y: 292.973,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.729,
    y: 292.973,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.068,
    y: 292.973,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.407,
    y: 292.973,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.746,
    y: 292.973,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.085,
    y: 292.973,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.423,
    y: 292.973,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.762,
    y: 292.973,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.101,
    y: 292.973,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.44,
    y: 292.973,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.051,
    y: 304.911,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.39,
    y: 304.911,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.729,
    y: 304.911,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.068,
    y: 304.911,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.407,
    y: 304.911,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.746,
    y: 304.911,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.085,
    y: 304.911,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.423,
    y: 304.911,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.762,
    y: 304.911,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.101,
    y: 304.911,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.44,
    y: 304.911,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.051,
    y: 316.849,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.39,
    y: 316.849,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.729,
    y: 316.849,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.068,
    y: 316.849,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.407,
    y: 316.849,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.746,
    y: 316.849,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.085,
    y: 316.849,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.423,
    y: 316.849,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.762,
    y: 316.849,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.101,
    y: 316.849,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.44,
    y: 316.849,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.068,
    y: 328.787,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.407,
    y: 328.787,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.746,
    y: 328.787,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.085,
    y: 328.787,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.423,
    y: 328.787,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.762,
    y: 328.787,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.101,
    y: 328.787,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.44,
    y: 328.787,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.407,
    y: 341.387,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.746,
    y: 341.387,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.085,
    y: 341.387,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.423,
    y: 341.387,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.762,
    y: 341.387,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.101,
    y: 341.387,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.44,
    y: 341.387,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 1.549,
    height: 8.575
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.264,
    y: 314.256,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.264,
    y: 332.012,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.264,
    y: 349.767,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.264,
    y: 367.523,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.264,
    y: 384.263,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.264,
    y: 402.018,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.956,
    y: 314.256,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.956,
    y: 332.012,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.956,
    y: 349.767,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.956,
    y: 367.523,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.956,
    y: 384.263,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.956,
    y: 402.018,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.648,
    y: 314.256,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.648,
    y: 332.012,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.648,
    y: 349.767,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.648,
    y: 367.523,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.648,
    y: 384.263,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.648,
    y: 402.018,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.34,
    y: 314.256,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.34,
    y: 332.012,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.34,
    y: 349.767,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.34,
    y: 367.523,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.34,
    y: 384.263,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.34,
    y: 402.018,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 3.66,
    height: 9.283
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.312,
    y: 184.805,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 3.045,
    height: 8.124
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.826,
    y: 184.805,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 3.045,
    height: 8.124
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.339,
    y: 184.805,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 3.045,
    height: 8.124
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.853,
    y: 184.805,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 3.045,
    height: 8.124
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.312,
    y: 198.335,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 3.045,
    height: 8.124
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.826,
    y: 198.335,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 3.045,
    height: 8.124
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.339,
    y: 198.335,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 3.045,
    height: 8.124
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.853,
    y: 198.335,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 3.045,
    height: 8.124
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.312,
    y: 211.865,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 3.045,
    height: 8.124
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.826,
    y: 211.865,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 3.045,
    height: 8.124
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.377,
    y: 184.805,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 3.045,
    height: 8.124
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.517,
    y: 267.107,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    width: 1.936,
    height: 7.447
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.351,
    y: 267.107,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    width: 1.936,
    height: 7.447
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.344,
    y: 267.107,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    width: 1.936,
    height: 7.447
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.177,
    y: 267.107,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    width: 1.936,
    height: 7.447
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.336,
    y: 267.107,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    width: 1.936,
    height: 7.447
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.169,
    y: 267.107,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    width: 1.936,
    height: 7.447
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.517,
    y: 280.039,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    width: 1.936,
    height: 7.447
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.351,
    y: 280.039,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    width: 1.936,
    height: 7.447
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.344,
    y: 280.039,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    width: 1.936,
    height: 7.447
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.177,
    y: 280.039,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    width: 1.936,
    height: 7.447
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.336,
    y: 280.039,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    width: 1.936,
    height: 7.447
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.169,
    y: 280.039,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    width: 1.936,
    height: 7.447
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.517,
    y: 292.97,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    width: 1.936,
    height: 7.447
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.351,
    y: 292.97,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    width: 1.936,
    height: 7.447
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.344,
    y: 292.97,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    width: 1.936,
    height: 7.447
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.177,
    y: 292.97,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    width: 1.936,
    height: 7.447
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.336,
    y: 292.97,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    width: 1.936,
    height: 7.447
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.169,
    y: 292.97,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    width: 1.936,
    height: 7.447
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.916,
    y: 324.18,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 3,
    height: 11.549
  }), /*#__PURE__*/React.createElement("rect", {
    x: 580.097,
    y: 324.18,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 3,
    height: 11.549
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.739,
    y: 324.18,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 3,
    height: 11.549
  }), /*#__PURE__*/React.createElement("rect", {
    x: 777.666,
    y: 326.58,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.278,
    height: 6.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 784.805,
    y: 326.58,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.278,
    height: 6.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 777.666,
    y: 326.58,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.278,
    height: 6.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 784.805,
    y: 326.58,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.278,
    height: 6.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 791.551,
    y: 326.58,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.278,
    height: 6.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 798.691,
    y: 326.58,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.278,
    height: 6.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 777.666,
    y: 338.227,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.278,
    height: 6.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 784.805,
    y: 338.227,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.278,
    height: 6.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 777.666,
    y: 338.227,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.278,
    height: 6.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 784.805,
    y: 338.227,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.278,
    height: 6.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 791.551,
    y: 338.227,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.278,
    height: 6.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 798.691,
    y: 338.227,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.278,
    height: 6.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 777.666,
    y: 350.623,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.278,
    height: 6.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 784.805,
    y: 350.623,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.278,
    height: 6.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 777.666,
    y: 350.623,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.278,
    height: 6.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 784.805,
    y: 350.623,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.278,
    height: 6.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 791.551,
    y: 350.623,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.278,
    height: 6.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 798.691,
    y: 350.623,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.278,
    height: 6.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806.494,
    y: 326.58,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.278,
    height: 6.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806.494,
    y: 338.227,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.278,
    height: 6.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813.634,
    y: 326.58,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.278,
    height: 6.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.791,
    y: 307.306,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.966,
    y: 307.306,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.14,
    y: 307.306,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.315,
    y: 307.306,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.791,
    y: 328.147,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.966,
    y: 328.147,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.14,
    y: 328.147,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.315,
    y: 328.147,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.791,
    y: 349.506,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.966,
    y: 349.506,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.14,
    y: 349.506,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.315,
    y: 349.506,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.791,
    y: 370.866,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.966,
    y: 370.866,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.14,
    y: 370.866,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.315,
    y: 370.866,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.791,
    y: 390.267,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.966,
    y: 390.267,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.14,
    y: 390.267,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.791,
    y: 411.907,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.966,
    y: 411.907,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.14,
    y: 411.907,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.315,
    y: 390.267,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.448,
    height: 10.126
  }), /*#__PURE__*/React.createElement("rect", {
    x: 876.541,
    y: 360.84,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.501,
    height: 5.812
  }), /*#__PURE__*/React.createElement("rect", {
    x: 876.541,
    y: 370.223,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.501,
    height: 5.812
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.957,
    y: 360.84,
    style: {
      opacity: 0.33,
      fill: "#FFFFFF"
    },
    width: 2.501,
    height: 5.812
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFound);
export default __webpack_public_path__ + "static/media/pageNotFound.a4bc62824bfc38907a6e8154e4c38ebc.svg";
export { ForwardRef as ReactComponent };